import * as brandColors from '../../utils/brandColors';

export default () => ({
  chip: {
    margin: '0.5em  !important',
    color: 'rgba(0,0,0,0.87) !important',
    backgroundColor: '#eceff1 !important',
  },
  chipWithSubheader: {
    margin: '1rem',
    color: 'rgba(0,0,0,0.87) !important',
  },
  cardHeaderTitle: {
    '& span': {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  cardSubheaderTitle: {
    '& span': {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    color: 'white',
  },
  cardHeaderAvatar: { marginRight: '10px  !important' },
  cardHeaderRoot: {
    padding: '8px 12px !important',
    boxShadow: `0 1px 3px 0 ${brandColors.grey[400]} !important`,
    borderBottom: brandColors.grey[200],
    background: brandColors.blueGrey[400],
    color: 'white',
  },
});
